import React from 'react';
import { useParams } from 'react-router-dom';
import LocationEditPage from '../../../features/locationEdit/LocationEditPage';

const LocationEditRoute = () => {
  const { id } = useParams();
  return <LocationEditPage locationId={id} />;
};

export default LocationEditRoute;
